import React from 'react';
import ImgixWrapper from '@common/components/ImgixWrapper';

import { isMobile } from '@utils/grid';

import { StyledThumbnail, ImagePlaceholder } from './Thumbnail.styles';

const desktopSize = {
  width: 124,
  height: 124,
};
const mobileSize = {
  width: 76,
  height: 76,
};

type ThumbnailProps = {
  url?: string | null;
  name: string;
  size?: {
    width: number;
    height: number;
  };
};

export const Thumbnail: React.FC<ThumbnailProps> = ({ url, name, size = desktopSize }) => {
  const isMobileDevice = isMobile();

  const width = isMobileDevice ? mobileSize.width : size.width;

  const height = isMobileDevice ? mobileSize.height : size.height;

  return (
    <StyledThumbnail>
      {url ? (
        <ImgixWrapper src={url} width={width} height={height} alt={name} />
      ) : (
        <ImagePlaceholder width={width} height={height} />
      )}
    </StyledThumbnail>
  );
};
